// Commonly used constants for the application

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const SHORT_DAY_NAMES = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

// All States for testing purposes
export const ALL_STATES = [
  { id: 'AL', name: 'Alabama' },
  { id: 'AK', name: 'Alaska' },
  { id: 'AZ', name: 'Arizona' },
  { id: 'AR', name: 'Arkansas' },
  { id: 'CA', name: 'California' },
  { id: 'CO', name: 'Colorado' },
  { id: 'CT', name: 'Connecticut' },
  { id: 'DE', name: 'Delaware' },
  { id: 'DC', name: 'DC' },
  { id: 'FL', name: 'Florida' },
  { id: 'GA', name: 'Georgia' },
  { id: 'HI', name: 'Hawaii' },
  { id: 'ID', name: 'Idaho' },
  { id: 'IL', name: 'Illinois' },
  { id: 'IN', name: 'Indiana' },
  { id: 'IA', name: 'Iowa' },
  { id: 'KS', name: 'Kansas' },
  { id: 'KY', name: 'Kentucky' },
  { id: 'LA', name: 'Louisiana' },
  { id: 'ME', name: 'Maine' },
  { id: 'MD', name: 'Maryland' },
  { id: 'MA', name: 'Massachusetts' },
  { id: 'MI', name: 'Michigan' },
  { id: 'MN', name: 'Minnesota' },
  { id: 'MS', name: 'Mississippi' },
  { id: 'MO', name: 'Missouri' },
  { id: 'MT', name: 'Montana' },
  { id: 'NE', name: 'Nebraska' },
  { id: 'NV', name: 'Nevada' },
  { id: 'NH', name: 'New Hampshire' },
  { id: 'NJ', name: 'New Jersey' },
  { id: 'NM', name: 'New Mexico' },
  { id: 'NY', name: 'New York' },
  { id: 'NC', name: 'North Carolina' },
  { id: 'ND', name: 'North Dakota' },
  { id: 'OH', name: 'Ohio' },
  { id: 'OK', name: 'Oklahoma' },
  { id: 'OR', name: 'Oregon' },
  { id: 'PA', name: 'Pennsylvania' },
  { id: 'RI', name: 'Rhode Island' },
  { id: 'SC', name: 'South Carolina' },
  { id: 'SD', name: 'South Dakota' },
  { id: 'TN', name: 'Tennessee' },
  { id: 'TX', name: 'Texas' },
  { id: 'US', name: 'United States' },
  { id: 'UT', name: 'Utah' },
  { id: 'VT', name: 'Vermont' },
  { id: 'VA', name: 'Virginia' },
  { id: 'WA', name: 'Washington' },
  { id: 'WV', name: 'West Virginia' },
  { id: 'WI', name: 'Wisconsin' },
  { id: 'WY', name: 'Wyoming' },
];

// Bill types by state
export const BILL_TYPES: { [index: string]: { id: string; name: string }[] } = {
  AK: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  AL: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  AR: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCMR', name: 'House Concurrent Memorial Resolution' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HMR', name: 'House Memorial' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCMR', name: 'Unknown Type (SCMR)' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SMR', name: 'Senate Memorial' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  AZ: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCM', name: 'House Concurrent Memorial' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HM', name: 'House Memorial' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCM', name: 'Senate Concurrent Memorial' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SM', name: 'Senate Memorial' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  CA: [
    { id: 'AB', name: 'Assembly Bill' },
    { id: 'ABX', name: 'Assembly Bill (Extraordinary Session)' },
    { id: 'ACA', name: 'Assembly Constitutional Amendment' },
    { id: 'ACAX', name: 'Assembly Constitutional Amendment (Extraordinary Session)' },
    { id: 'ACR', name: 'Assembly Concurrent Resolution' },
    { id: 'AJR', name: 'Assembly Joint Resolution' },
    { id: 'AR', name: 'Assembly Resolution' },
    { id: 'HB', name: 'House Bill' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SBX', name: 'Senate Bill (Extraordinary Session)' },
    { id: 'SCA', name: 'Senate Constitutional Amendment' },
    { id: 'SCAX', name: 'Senate Constitutional Amendment (Extraordinary Session)' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  CO: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJM', name: 'House Joint Memorial' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HM', name: 'House Memorial' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJM', name: 'Senate Joint Memorial' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SM', name: 'Senate Memorial' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  CT: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJ', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJ', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  DC: [
    { id: 'B', name: 'Bill' },
    { id: 'CER', name: 'Ceremonial Resolution' },
    { id: 'PR', name: 'Proposed Resolution' },
  ],
  DE: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  FL: [
    { id: 'H', name: 'House Bill' },
    { id: 'S', name: 'Senate Bill' },
  ],
  GA: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  HI: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  IA: [
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HF', name: 'House File' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'HSB', name: 'House Study Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SF', name: 'Senate File' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
    { id: 'SSB', name: 'Senate Study Bill' },
  ],
  ID: [
    { id: 'H', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJM', name: 'House Joint Memorial' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HP', name: 'House Paper' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'S', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJM', name: 'Senate Joint Memorial' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SP', name: 'Senate Paper' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  IL: [
    { id: 'EO', name: 'Executive Order' },
    { id: 'HB', name: 'House Bill' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HJRCA', name: 'House Joint Resolution Constitutional Amendment' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'JSR', name: 'Joint Session Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SJRCA', name: 'Senate Joint Resolution Constitutional Amendment' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  IN: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  KS: [
    { id: 'H', name: 'House Bill' },
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'S', name: 'Senate Bill' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  KY: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  LA: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HCSR', name: 'House Concurrent Study Request' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'HSR', name: 'House Study Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SCSR', name: 'Senate Concurrent Study Request' },
    { id: 'SR', name: 'Senate Resolution' },
    { id: 'SSR', name: 'Senate Study Resolution' },
  ],
  MA: [
    { id: 'H', name: 'House Bill' },
    { id: 'S', name: 'Senate Bill' },
  ],
  MD: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJ', name: 'House Joint Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJ', name: 'Senate Joint Resolution' },
  ],
  ME: [
    { id: 'HP', name: 'House Paper' },
    { id: 'LD', name: 'Legislative Document (Bill)' },
    { id: 'SP', name: 'Senate Paper' },
  ],
  MI: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'JR', name: 'Unknown Type (JR)' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  MN: [
    { id: 'HC', name: 'House Commemoration' },
    { id: 'HF', name: 'House File' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SC', name: 'Senate Commemoration' },
    { id: 'SF', name: 'Senate File' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  MO: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCB', name: 'House Committee Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'HRB', name: 'House Repeal Bill' },
    { id: 'HRM', name: 'House Remonstration' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
    { id: 'SRB', name: 'Senate Repeal Bill' },
    { id: 'SRM', name: 'Senate Remonstration' },
  ],
  MS: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HC', name: 'House Commemoration' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'JR', name: 'Unknown Type (JR)' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SC', name: 'Senate Commemoration' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  MT: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJ', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJ', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  NC: [
    { id: 'H', name: 'House Bill' },
    { id: 'S', name: 'Senate Bill' },
  ],
  ND: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HM', name: 'House Memorial' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SM', name: 'Senate Memorial' },
  ],
  NE: [
    { id: 'LB', name: 'Legislative Bill' },
    { id: 'LBA', name: 'Legislative Bill Amendment' },
    { id: 'LR', name: 'Legislative Resolution' },
    { id: 'LRCA', name: 'Legislative Resolution Constitutional Amendment' },
  ],
  NH: [
    { id: 'CACR', name: 'Constitutional Amendment Concurrent Resolution' },
    { id: 'HA', name: 'House Address' },
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
    { id: 'SSHB', name: 'Second Substitute House Bill' },
    { id: 'SSSB', name: 'Second Substitute Senate Bill' },
  ],
  NJ: [
    { id: 'A', name: 'Assembly Bill' },
    { id: 'ACR', name: 'Assembly Concurrent Resolution' },
    { id: 'AJR', name: 'Assembly Joint Resolution' },
    { id: 'AR', name: 'Assembly Resolution' },
    { id: 'S', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  NM: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJM', name: 'House Joint Memorial' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HM', name: 'House Memorial' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJM', name: 'Senate Joint Memorial' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SM', name: 'Senate Memorial' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  NV: [
    { id: 'AB', name: 'Assembly Bill' },
    { id: 'ABA', name: 'Assembly Budget Act' },
    { id: 'ACR', name: 'Assembly Concurrent Resolution' },
    { id: 'AJR', name: 'Assembly Joint Resolution' },
    { id: 'AJRA', name: 'Assembly Joint Resolution Amendment' },
    { id: 'AR', name: 'Assembly Resolution' },
    { id: 'IP', name: 'Initiative Petition' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SBA', name: 'Senate Bill Amendment' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SJRA', name: 'Senate Joint Resolution Amendment' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  NY: [
    { id: 'A', name: 'Assembly Bill' },
    { id: 'B', name: 'Bill' },
    { id: 'C', name: 'Commendation' },
    { id: 'J', name: 'Joint Resolution' },
    { id: 'K', name: 'Unknown Legislative Document' },
    { id: 'S', name: 'Senate Bill' },
  ],
  OH: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  OK: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  OR: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJM', name: 'House Joint Memorial' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HM', name: 'House Memorial' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJM', name: 'Senate Joint Memorial' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SM', name: 'Senate Memorial' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  PA: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  RI: [
    { id: 'H', name: 'House Bill' },
    { id: 'S', name: 'Senate Bill' },
  ],
  SC: [
    { id: 'H', name: 'House Bill' },
    { id: 'S', name: 'Senate Bill' },
  ],
  SD: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HC', name: 'House Commemoration' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SC', name: 'Senate Commemoration' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  TN: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  TX: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HCSR', name: 'House Concurrent Study Request' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'HSR', name: 'House Study Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
    { id: 'SSR', name: 'Senate Study Resolution' },
  ],
  UT: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HBS', name: 'House Bill Substitute' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HCRS', name: 'House Concurrent Resolution Substitute' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HJRS', name: 'House Joint Resolution Substitute' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SBS', name: 'Senate Bill Substitute' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SCRS', name: 'Senate Concurrent Resolution Substitute' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SJRS', name: 'Senate Joint Resolution Substitute' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  VA: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  VT: [
    { id: 'H', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'JRH', name: 'Joint Resolution—House' },
    { id: 'JRS', name: 'Joint Resolution—Senate' },
    { id: 'S', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  WA: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HI', name: 'House Initiative' },
    { id: 'HJM', name: 'House Joint Memorial' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SI', name: 'Senate Initiative' },
    { id: 'SJM', name: 'Senate Joint Memorial' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  WI: [
    { id: 'AB', name: 'Assembly Bill' },
    { id: 'ABDE', name: 'Assembly Bill (Draft Engrossed)' },
    { id: 'AJR', name: 'Assembly Joint Resolution' },
    { id: 'AR', name: 'Assembly Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SBJN', name: 'Senate Bill (Special Type)' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  WV: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HCR', name: 'House Concurrent Resolution' },
    { id: 'HJR', name: 'House Joint Resolution' },
    { id: 'HR', name: 'House Resolution' },
    { id: 'SB', name: 'Senate Bill' },
    { id: 'SCR', name: 'Senate Concurrent Resolution' },
    { id: 'SJR', name: 'Senate Joint Resolution' },
    { id: 'SR', name: 'Senate Resolution' },
  ],
  WY: [
    { id: 'HB', name: 'House Bill' },
    { id: 'HJ', name: 'House Joint Resolution' },
    { id: 'SF', name: 'Senate File' },
    { id: 'SJ', name: 'Senate Joint Resolution' },
  ],
};

// Party abbreviations
export const PARTIES = {
  Democratic: 'D',
  Republican: 'R',
  Independent: 'I',
  Libertarian: 'L',
  Green: 'G',
};

export const TIMEZONES: { [key: string]: string } = {
  AL: 'America/Chicago',
  AK: 'America/Anchorage',
  AZ: 'America/Phoenix',
  AR: 'America/Chicago',
  CA: 'America/Los_Angeles',
  CO: 'America/Denver',
  CT: 'America/New_York',
  DC: 'America/New_York',
  DE: 'America/New_York',
  FL: 'America/New_York',
  GA: 'America/New_York',
  HI: 'Pacific/Honolulu',
  ID: 'America/Boise', // (Note: northern Idaho is Pacific Time, but most of ID is Mountain)
  IL: 'America/Chicago',
  IN: 'America/Indiana/Indianapolis',
  IA: 'America/Chicago',
  KS: 'America/Chicago',
  KY: 'America/New_York',
  LA: 'America/Chicago',
  ME: 'America/New_York',
  MD: 'America/New_York',
  MA: 'America/New_York',
  MI: 'America/Detroit',
  MN: 'America/Chicago',
  MS: 'America/Chicago',
  MO: 'America/Chicago',
  MT: 'America/Denver',
  NE: 'America/Chicago',
  NV: 'America/Los_Angeles',
  NH: 'America/New_York',
  NJ: 'America/New_York',
  NM: 'America/Denver',
  NY: 'America/New_York',
  NC: 'America/New_York',
  ND: 'America/Chicago',
  OH: 'America/New_York',
  OK: 'America/Chicago',
  OR: 'America/Los_Angeles',
  PA: 'America/New_York',
  RI: 'America/New_York',
  SC: 'America/New_York',
  SD: 'America/Chicago',
  TN: 'America/Chicago',
  TX: 'America/Chicago',
  UT: 'America/Denver',
  VT: 'America/New_York',
  VA: 'America/New_York',
  WA: 'America/Los_Angeles',
  WV: 'America/New_York',
  WI: 'America/Chicago',
  WY: 'America/Denver',
};

export const STATUTE_CODES = [
  { value: 'AG', label: 'Agriculture Code' },
  { value: 'AL', label: 'Alcoholic Beverage Code' },
  { value: 'BA', label: 'Banking Act' },
  { value: 'BAC', label: 'Business and Commerce Code' },
  { value: 'BCA', label: 'Business Corporation Act' },
  { value: 'BOC', label: 'Business Organizations Code' },
  { value: 'CCP', label: 'Code of Criminal Procedure' },
  { value: 'CON', label: 'Constitution' },
  { value: 'CPR', label: 'Civil Practices Code' },
  { value: 'EC', label: 'Estates Code' },
  { value: 'ED', label: 'Education Code' },
  { value: 'EL', label: 'Election Code' },
  { value: 'FAM', label: 'Family Code' },
  { value: 'FIN', label: 'Finance Code' },
  { value: 'GOV', label: 'Government Code' },
  { value: 'HAS', label: 'Health and Safety Code' },
  { value: 'HUM', label: 'Human Resources Code' },
  { value: 'INS', label: 'Insurance Code' },
  { value: 'LAB', label: 'Labor Code' },
  { value: 'LGC', label: 'Local Government Code' },
  { value: 'NAT', label: 'Natural Resources Code' },
  { value: 'NR', label: '(No Code References)' },
  { value: 'OC', label: 'Occupations Code' },
  { value: 'PAW', label: 'Parks and Wildlife Code' },
  { value: 'PC', label: 'Penal Code' },
  { value: 'PRC', label: 'Probate Code' },
  { value: 'PRO', label: 'Property Code' },
  { value: 'PUR', label: 'Public Utility Regulatory Act' },
  { value: 'RCS', label: 'Revised Civil Statutes' },
  { value: 'RET', label: 'Retirement Code' },
  { value: 'SDC', label: 'Special Districts Code' },
  { value: 'SES', label: 'Session Laws' },
  { value: 'TAX', label: 'Tax Code' },
  { value: 'TRC', label: 'Transportation Code' },
  { value: 'UC', label: 'Utilities Code' },
  { value: 'VCS', label: "Vernon's Civil Statutes" },
  { value: 'WAT', label: 'Water Code' },
  { value: 'CHC', label: "Children's Code" },
  { value: 'CC', label: 'Civil Code' },
  { value: 'CE', label: 'Code of Evidence' },
  { value: 'CJP', label: 'Code of Juvenile Procedure' },
  { value: 'CRP', label: 'Code of Criminal Procedure' },
  { value: 'CCP', label: 'Code of Civil Procedure' },
  { value: 'CON', label: 'Constitution' },
  { value: 'RS', label: 'Revised Statutes' },
  { value: 'SES', label: 'Session Law' },
];

export const BILL_SUBJECTS = [
  { value: 1, label: 'Higher Education' },
  { value: 2, label: 'Insurance' },
  { value: 3, label: 'Labor and Employment' },
  { value: 4, label: 'Water' },
  { value: 5, label: 'Alcohol and Tobacco Products' },
  { value: 6, label: 'Health and Medical Practice' },
  { value: 7, label: 'Schools and Teachers' },
  { value: 8, label: 'County Affairs' },
  { value: 9, label: 'Courts and Civil Matters' },
  { value: 10, label: 'Municipalities/City Government' },
  { value: 11, label: 'Penal Code/Criminal Procedure' },
  { value: 12, label: 'Transportation' },
  { value: 13, label: 'Business and Manufacturing' },
  { value: 15, label: 'Utilities' },
  { value: 16, label: 'Energy Resources & Chemicals' },
  { value: 17, label: 'Public Employees/Retirement' },
  { value: 18, label: 'State Affairs' },
  { value: 19, label: 'Welfare' },
  { value: 20, label: 'Land, Housing and Real Estate' },
  { value: 21, label: 'Family and Juveniles' },
  { value: 22, label: 'Amusements, Games, Sports' },
  { value: 23, label: 'Construction and Materials' },
  { value: 24, label: 'Banks, Securities and Loans' },
  { value: 25, label: 'Constitutional Amendments' },
  { value: 26, label: 'Elections' },
  { value: 27, label: 'Agriculture and Ranching' },
  { value: 28, label: 'Law Enforcement/Fire Control' },
  { value: 30, label: 'Parks and Wildlife' },
  { value: 32, label: 'Environment and Pollution' },
  { value: 40, label: 'Interim Studies' },
  { value: 41, label: 'Sue the State Resolutions' },
  { value: 60, label: 'Taxation' },
  { value: 61, label: 'Cannabis/Drug Legalization' },
  { value: 62, label: 'Civil Rights' },
  { value: 63, label: 'Consumer Protection' },
  { value: 64, label: 'Immigration' },
  { value: 65, label: 'Media/Entertainment' },
  { value: 66, label: 'Non-Profit' },
  { value: 67, label: 'Privacy/Internet' },
  { value: 68, label: 'Professional/Vocational Licensing' },
  { value: 69, label: 'Public Safety' },
  { value: 70, label: 'Public Sector' },
  { value: 71, label: 'RFP/Procurement' },
  { value: 72, label: 'Science/Technology' },
  { value: 73, label: 'Telecommunications' },
  { value: 74, label: 'Tourism/Hospitality' },
];

export const DEFAULT_BILL_TAGS = [
  { id: 'high-priority', name: 'High Priority', color: 'bg-red-100 text-red-800 border-red-200' },
  {
    id: 'low-priority',
    name: 'Low Priority',
    color: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  {
    id: 'high-impact',
    name: 'High Impact',
    color: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  { id: 'low-impact', name: 'Low Impact', color: 'bg-blue-100 text-blue-800 border-blue-200' },
  { id: 'monitoring', name: 'Monitoring', color: 'bg-gray-100 text-gray-800 border-gray-200' },
  { id: 'our-package', name: 'Our Package', color: 'bg-green-100 text-green-800 border-green-200' },
  { id: 'support', name: 'Support', color: 'bg-green-100 text-green-800 border-green-200' },
  { id: 'oppose', name: 'Oppose', color: 'bg-red-100 text-red-800 border-red-200' },
];

export const ACTION_CODES = [
  { code: 1, description: 'Prefiled' },
  { code: 2, description: 'Introduced' },
  { code: 4, description: 'Received in the Senate' },
  { code: 6, description: 'Referred to Senate Committee on' },
  { code: 7, description: 'Received in the House' },
  { code: 9, description: 'Referred to House Committee on' },
  { code: 10, description: 'Involuntarily Deferred' },
  { code: 11, description: 'Reported favorably from committee on' },
  { code: 12, description: 'Reported favorably from committee as amended' },
  { code: 13, description: 'Reported from committee as substituted' },
  { code: 14, description: 'Reported unfavorably from committee' },
  { code: 15, description: 'Reported from committee without action' },
  { code: 17, description: 'Recommitted' },
  { code: 18, description: 'Notice Removed' },
  { code: 19, description: 'Laid on the table' },
  { code: 20, description: 'Returned to the calendar - subject to call' },
  { code: 21, description: 'Called from the table' },
  { code: 22, description: 'Discharged from committee' },
  { code: 23, description: 'Veto Message Read' },
  { code: 24, description: 'Committee Amendments Rejected' },
  { code: 25, description: 'Passed to third reading on Local Calendar' },
  { code: 27, description: 'Passed to third reading' },
  { code: 31, description: 'Reconsidered' },
  { code: 32, description: 'Failed to pass' },
  { code: 33, description: 'Indefinitely Postponed' },
  { code: 34, description: 'Passed' },
  { code: 35, description: 'House concurred in Senate amendments' },
  { code: 36, description: 'House refused to concur in Senate amendments' },
  { code: 37, description: 'House appointed a conference committee' },
  { code: 38, description: 'House adopted the conference report' },
  { code: 39, description: 'House rejected the conference report' },
  { code: 40, description: 'Senate concurred in House amendments' },
  { code: 41, description: 'Senate refused to concur in House amendments' },
  { code: 42, description: 'Senate appointed conference committee' },
  { code: 43, description: 'Senate adopted the conference report' },
  { code: 44, description: 'Senate Rejected Conference Committee Report' },
  { code: 45, description: 'Signed by the Governor' },
  { code: 46, description: 'Filed without signature' },
  { code: 47, description: 'Vetoed' },
  { code: 48, description: 'Committee Hearing Set For' },
  { code: 49, description: 'House Late Passage Approval' },
  { code: 50, description: 'Senate Late Passage Approval' },
  { code: 51, description: 'Floor amendment(s) adopted' },
  { code: 52, description: 'Legislative Bureau Floor Amendment Adopted' },
  { code: 54, description: 'Set on the House Orders' },
  { code: 55, description: 'Local & Consent Calendar' },
  { code: 56, description: 'Scheduled for House floor debate' },
  { code: 57, description: 'Scheduled for Senate floor debate' },
  { code: 59, description: 'Committee Hearing Cancelled' },
  { code: 63, description: 'Special Order' },
  { code: 64, description: 'Set on the Senate Orders' },
  { code: 65, description: 'Senate Recommitted to Conference Committee' },
  { code: 66, description: 'Recalled from Conference Committee' },
  { code: 67, description: 'House Recommitted to Conference Committee' },
  { code: 70, description: "House Vote to Override Governor's Veto" },
  { code: 71, description: "Senate Vote to Override Governor's Veto" },
  { code: 72, description: 'Enrolled' },
  { code: 73, description: 'Withdrawn' },
  { code: 74, description: 'Effective' },
  { code: 75, description: '(Notes)' },
  { code: 81, description: 'Committee amendment(s) adopted' },
  { code: 89, description: 'Floor Amendment Withdrawn' },
  { code: 90, description: 'Laid out for consideration' },
  { code: 95, description: 'Filed with the Secretary of State' },
  { code: 96, description: 'Sent to the Governor' },
  { code: 98, description: 'Laid out for consideration in the Senate' },
  { code: 99, description: 'Laid out for consideration in the House' },
  { code: 100, description: 'Line Item(s) Veto' },
  { code: 105, description: 'Removed from hearing' },
  { code: 108, description: 'Substituted by' },
  { code: 109, description: 'Substituted for' },
  { code: 110, description: 'Voluntarily Deferred in Committee' },
  { code: 111, description: 'Voted Favorably from Committee' },
  { code: 112, description: 'Voted with Amendments from Committee' },
  { code: 113, description: 'Voted by Substitute from Committee' },
  { code: 114, description: 'Voted Unfavorably from Committee' },
  { code: 115, description: 'Voted Without Action from Committee' },
  { code: 116, description: 'Voted to Involuntarily Defer in Committee' },
  { code: 117, description: 'Not Heard in Committee' },
  { code: 118, description: 'Sent to the Legislative Bureau' },
  { code: 119, description: 'Vote failed in committee' },
  { code: 120, description: 'Passed Over on Final Passage' },
  { code: 121, description: 'No action taken in committee' },
  { code: 130, description: 'Laid out for consideration in committee' },
  { code: 131, description: 'Laid out for consideration in subcommittee' },
  { code: 132, description: 'Committee action pending' },
  { code: 133, description: 'Subcommittee action pending' },
  { code: 134, description: 'Sent to subcommittee' },
  { code: 135, description: 'Committee hearing postponed' },
  { code: 140, description: 'Returned to full committee without amendments' },
  { code: 141, description: 'Returned to full committee with amendments' },
  { code: 142, description: 'Returned to full committee as substituted' },
];

export const PROGRESS_STATUSES = [
  { value: 0, label: 'N/A (Pre-filed or pre-introduction)' },
  { value: 1, label: 'Introduced' },
  { value: 2, label: 'Engrossed' },
  { value: 3, label: 'Enrolled' },
  { value: 4, label: 'Passed' },
  { value: 5, label: 'Vetoed' },
  { value: 6, label: 'Failed (Limited support based on state)' },
  { value: 7, label: 'Override (Progress array only)' },
  { value: 8, label: 'Chaptered (Progress array only)' },
  { value: 9, label: 'Refer (Progress array only)' },
  { value: 10, label: 'Report Pass (Progress array only)' },
  { value: 11, label: 'Report DNP (Progress array only)' },
  { value: 12, label: 'Draft (Progress array only)' },
];

export const FIPS_TO_ABBR: Record<string, string> = {
  '01': 'AL',
  '02': 'AK',
  '04': 'AZ',
  '05': 'AR',
  '06': 'CA',
  '08': 'CO',
  '09': 'CT',
  '10': 'DE',
  '12': 'FL',
  '13': 'GA',
  '15': 'HI',
  '16': 'ID',
  '17': 'IL',
  '18': 'IN',
  '19': 'IA',
  '20': 'KS',
  '21': 'KY',
  '22': 'LA',
  '23': 'ME',
  '24': 'MD',
  '25': 'MA',
  '26': 'MI',
  '27': 'MN',
  '28': 'MS',
  '29': 'MO',
  '30': 'MT',
  '31': 'NE',
  '32': 'NV',
  '33': 'NH',
  '34': 'NJ',
  '35': 'NM',
  '36': 'NY',
  '37': 'NC',
  '38': 'ND',
  '39': 'OH',
  '40': 'OK',
  '41': 'OR',
  '42': 'PA',
  '44': 'RI',
  '45': 'SC',
  '46': 'SD',
  '47': 'TN',
  '48': 'TX',
  '49': 'UT',
  '50': 'VT',
  '51': 'VA',
  '53': 'WA',
  '54': 'WV',
  '55': 'WI',
  '56': 'WY',
  '11': 'DC',
};

export const NAME_TO_ABBR: Record<string, string> = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  'District of Columbia': 'DC',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  'United States': 'US',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};

// Auto-generated – DO NOT EDIT
export const STATES = [
  {
    id: 'AL',
    name: 'Alabama',
  },
  {
    id: 'AK',
    name: 'Alaska',
  },
  {
    id: 'AZ',
    name: 'Arizona',
  },
  {
    id: 'AR',
    name: 'Arkansas',
  },
  {
    id: 'CA',
    name: 'California',
  },
  {
    id: 'CO',
    name: 'Colorado',
  },
  {
    id: 'CT',
    name: 'Connecticut',
  },
  {
    id: 'DE',
    name: 'Delaware',
  },
  {
    id: 'DC',
    name: 'DC',
  },
  {
    id: 'FL',
    name: 'Florida',
  },
  {
    id: 'GA',
    name: 'Georgia',
  },
  {
    id: 'HI',
    name: 'Hawaii',
  },
  {
    id: 'ID',
    name: 'Idaho',
  },
  {
    id: 'IL',
    name: 'Illinois',
  },
  {
    id: 'IN',
    name: 'Indiana',
  },
  {
    id: 'IA',
    name: 'Iowa',
  },
  {
    id: 'KS',
    name: 'Kansas',
  },
  {
    id: 'KY',
    name: 'Kentucky',
  },
  {
    id: 'LA',
    name: 'Louisiana',
  },
  {
    id: 'ME',
    name: 'Maine',
  },
  {
    id: 'MD',
    name: 'Maryland',
  },
  {
    id: 'MA',
    name: 'Massachusetts',
  },
  {
    id: 'MI',
    name: 'Michigan',
  },
  {
    id: 'MN',
    name: 'Minnesota',
  },
  {
    id: 'MS',
    name: 'Mississippi',
  },
  {
    id: 'MO',
    name: 'Missouri',
  },
  {
    id: 'MT',
    name: 'Montana',
  },
  {
    id: 'NE',
    name: 'Nebraska',
  },
  {
    id: 'NV',
    name: 'Nevada',
  },
  {
    id: 'NH',
    name: 'New Hampshire',
  },
  {
    id: 'NJ',
    name: 'New Jersey',
  },
  {
    id: 'NM',
    name: 'New Mexico',
  },
  {
    id: 'NY',
    name: 'New York',
  },
  {
    id: 'NC',
    name: 'North Carolina',
  },
  {
    id: 'ND',
    name: 'North Dakota',
  },
  {
    id: 'OH',
    name: 'Ohio',
  },
  {
    id: 'OK',
    name: 'Oklahoma',
  },
  {
    id: 'OR',
    name: 'Oregon',
  },
  {
    id: 'PA',
    name: 'Pennsylvania',
  },
  {
    id: 'RI',
    name: 'Rhode Island',
  },
  {
    id: 'SC',
    name: 'South Carolina',
  },
  {
    id: 'SD',
    name: 'South Dakota',
  },
  {
    id: 'TN',
    name: 'Tennessee',
  },
  {
    id: 'TX',
    name: 'Texas',
  },
  {
    id: 'US',
    name: 'United States',
  },
  {
    id: 'UT',
    name: 'Utah',
  },
  {
    id: 'VT',
    name: 'Vermont',
  },
  {
    id: 'VA',
    name: 'Virginia',
  },
  {
    id: 'WA',
    name: 'Washington',
  },
  {
    id: 'WV',
    name: 'West Virginia',
  },
  {
    id: 'WI',
    name: 'Wisconsin',
  },
  {
    id: 'WY',
    name: 'Wyoming',
  },
];

export const STATE_CHAMBERS: { [index: string]: { id: string; name: string }[] } = {
  AK: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  AL: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  AR: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  AZ: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  CA: [
    { id: 'lower', name: 'State Assembly' },
    { id: 'upper', name: 'Senate' },
  ],
  CO: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  CT: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  DE: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  FL: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  GA: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  HI: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  IA: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  ID: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  IL: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  IN: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  KS: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  KY: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  LA: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MA: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MD: [
    { id: 'lower', name: 'House of Delegates' },
    { id: 'upper', name: 'Senate' },
  ],
  ME: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MI: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MN: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MO: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MS: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  MT: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  NC: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  ND: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  NE: [{ id: 'unicameral', name: 'Unicameral' }],
  NH: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  NJ: [
    { id: 'lower', name: 'General Assembly' },
    { id: 'upper', name: 'Senate' },
  ],
  NM: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  NV: [
    { id: 'lower', name: 'Assembly' },
    { id: 'upper', name: 'Senate' },
  ],
  NY: [
    { id: 'lower', name: 'Assembly' },
    { id: 'upper', name: 'Senate' },
  ],
  OH: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  OK: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  OR: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  PA: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  RI: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  SC: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  SD: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  TN: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  TX: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  UT: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  VA: [
    { id: 'lower', name: 'House of Delegates' },
    { id: 'upper', name: 'Senate' },
  ],
  VT: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  WA: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
  WI: [
    { id: 'lower', name: 'State Assembly' },
    { id: 'upper', name: 'Senate' },
  ],
  WV: [
    { id: 'lower', name: 'House of Delegates' },
    { id: 'upper', name: 'Senate' },
  ],
  WY: [
    { id: 'lower', name: 'House of Representatives' },
    { id: 'upper', name: 'Senate' },
  ],
};
